import Toast from "components/atoms/Toast/index";

import { FormSend } from "../../SendForm/index";

export default function Step2({ step2Result, step3Result }) {
  return (
    <div className="mb-8">
      <div className="mb-6 lg:mb-8">
        {step2Result == "yes" ? (
          <p className="text-center">
            Your company is required to file an annual tax return on or before
            31st March.
          </p>
        ) : step3Result == "yes" ? (
          <>
            <p className="mb-3">
              Your company is required to provide the following documents:
            </p>
            <p className="mb-4" style={{ fontWeight: 500 }}>
              (1) Certificate of Tax Exemption
            </p>
            <p className="mb-2">
              To apply for a certificate of tax exemption, you must fill out and
              submit:
            </p>
            <ul className="mb-3 pl-2">
              <li className="relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0">
                Form E to the International Financial Services Commission; and
              </li>
              <li className="relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0">
                The Annual Declaration of Tax Exemption to the Belize
                International Corporate Affairs Registry (BICAR).
              </li>
            </ul>
            <p className="mb-4">
              You will then receive the certificate if qualified.
            </p>
            <p className="mb-4" style={{ fontWeight: 500 }}>
              (2) Proof of your company’s tax residency outside Belize
            </p>
            <p className="mb-3">
              Proof can be an authorized letter or certificate or any evidence
              stating that you have tax residence in a jurisdiction.
            </p>
            <p className="mb-3">
              The due date for the provisions is on or before 31st March.
            </p>
            <p>
              <i>*The due date is based on Belize’s recent extension.</i>
            </p>
          </>
        ) : (
          <>
            <p className="mb-3">
              Your company is required to provide Certificate of Tax Exemption.
            </p>
            <p className="mb-2">
              To apply for a certificate of tax exemption, you must fill out and
              submit:
            </p>
            <ul className="mb-3 pl-2">
              <li className="relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0">
                Form E to the International Financial Services Commission; and
              </li>
              <li className="relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0">
                The Annual Declaration of Tax Exemption to the Belize
                International Corporate Affairs Registry (BICAR).
              </li>
            </ul>
            <p className="mb-3">
              You will then receive the certificate if qualified.
            </p>
            <p className="mb-3">
              The due date for the submission is on or before 31st March.
            </p>
            <p>
              <i>*The due date is based on Belize’s recent extension.</i>
            </p>
          </>
        )}
      </div>
      <div className="px-4 lg:px-0">
        <p className="mb-4 text-center font-medium text-[#2C2C51]">
          Need more help? Leave your details and we&apos;ll get back to you.
        </p>
        <Toast>
          <FormSend triggerName="Ebook - Offshore Company" />
        </Toast>
      </div>
    </div>
  );
}
